export default "__VITE_ASSET__CjRak9BW__"